import { CheckboxGroupRangeType } from 'apps/nagel-cal-disposition/src/models/filterServiceTypes';
import { PICKUP_PLANNING_CARD_CHIPS } from './pickupPlanning';

export const FILTER_OPERATORS = {
    EQUAL: 'Equals',
    GREATER_THAN_OR_EQUAL: 'GreaterThanOrEqual',
    LESS_THAN_OR_EQUAL: 'LessThanOrEqual',
    IN: 'in',
    IN_RANGE: 'InRange',
    ONE_OF: 'OneOf',
    ONE_OF_BETWEEN: 'OneOfBetween',
    LIKE: 'Like',
    CONTAINS: 'Contains',
    CONTAINS_IGNORE_CASE: 'containsIgnoreCase'
};

export type FilterOperatorType = (typeof FILTER_OPERATORS)[keyof typeof FILTER_OPERATORS];

export const FILTER_STRATEGY_TYPES = {
    INPUT_STRATEGY: 'input',
    NUMBER_INPUT_STRATEGY: 'numberInput',
    DATE_PICKER_STRATEGY: 'datepicker',
    TODAY_STRATEGY: 'today',
    DATE_RANGE_STRATEGY: 'dateRangePicker',
    DATE_TIME_RANGE_STRATEGY: 'dateTimeRangePicker',
    AUTOCOMPLETE_STRATEGY: 'autocomplete',
    CHECKBOX_GROUP_STRATEGY: 'checkboxGroup',
    INPUT_NUMBER_RANGE_STRATEGY: 'inputNumberRange',
    CHECKBOX_GROUP_RANGE_STRATEGY: 'checkboxGroupRange',
    EXTERNAL_FILTER_STRATEGY: 'externalFilter',
    MULTISELECT_AUTOCOMPLETE_STRATEGY: 'multiselectAutocomplete'
};


export const PICKUP_PLANNING_FILTERS_TYPES_TO_STRATEGY_MAP = {
    'OneOfLegTypes': FILTER_STRATEGY_TYPES.EXTERNAL_FILTER_STRATEGY,
    'IsVLType': FILTER_STRATEGY_TYPES.EXTERNAL_FILTER_STRATEGY,
    'IsHLType': FILTER_STRATEGY_TYPES.EXTERNAL_FILTER_STRATEGY,
    'IsNlType': FILTER_STRATEGY_TYPES.EXTERNAL_FILTER_STRATEGY,
    'HasProductGroup': FILTER_STRATEGY_TYPES.CHECKBOX_GROUP_STRATEGY,
    'ProductGroup': FILTER_STRATEGY_TYPES.CHECKBOX_GROUP_STRATEGY,
    'DeliveryDateTo': FILTER_STRATEGY_TYPES.DATE_RANGE_STRATEGY,
    'PickupDateFrom': FILTER_STRATEGY_TYPES.DATE_RANGE_STRATEGY,
    'OriginZipCode': FILTER_STRATEGY_TYPES.INPUT_STRATEGY,
    'HasTrafficFlow': FILTER_STRATEGY_TYPES.CHECKBOX_GROUP_STRATEGY,
    'TrafficFlow': FILTER_STRATEGY_TYPES.CHECKBOX_GROUP_STRATEGY,
    'HasVolumePalletRange': FILTER_STRATEGY_TYPES.CHECKBOX_GROUP_RANGE_STRATEGY,
    'VolumePalletSpaces': FILTER_STRATEGY_TYPES.CHECKBOX_GROUP_RANGE_STRATEGY,
    'HasFloorPalletRange': FILTER_STRATEGY_TYPES.CHECKBOX_GROUP_RANGE_STRATEGY,
    'FloorPalletSpaces': FILTER_STRATEGY_TYPES.CHECKBOX_GROUP_RANGE_STRATEGY,
    'TotalWeight': FILTER_STRATEGY_TYPES.INPUT_NUMBER_RANGE_STRATEGY,
    'Weight': FILTER_STRATEGY_TYPES.INPUT_NUMBER_RANGE_STRATEGY
};


/* eslint-disable no-magic-numbers*/
export const CHECKBOX_GROUP_RANGE_KEY_VALUES_MAP: {[key: string]: CheckboxGroupRangeType} = {
    'lessThanFive': {from: 0, to: 5},
    'fiveToTen': {from: 5, to: 10},
    'tenToFifteen': {from: 10, to: 15},
    'fifteenToTwenty': {from: 15, to: 20},
    'twentyToThirty': {from: 20, to: 30},
    'moreThanThirty':  {from: 30, to: 1000}
};
/* eslint-enable no-magic-numbers*/

export const CHECKBOX_GROUP_KEY_VALUES_MAP: {[key: string]: string} = {
    [PICKUP_PLANNING_CARD_CHIPS.FRUITS_AND_VEGETABLES]: '08',
    [PICKUP_PLANNING_CARD_CHIPS.DRY]: '03',
    [PICKUP_PLANNING_CARD_CHIPS.FROZEN]: '04',
    [PICKUP_PLANNING_CARD_CHIPS.LIQUID]: '05',
    [PICKUP_PLANNING_CARD_CHIPS.FRESH]: '01',
    [PICKUP_PLANNING_CARD_CHIPS.ULTRA_FRESH]: '02',
    [PICKUP_PLANNING_CARD_CHIPS.AMBIENT]: '07'
};

export const SAVE_BUTTON_FIELD_NAME = 'filterApplyButton';

export const PICKUP_PLANNING_TO_FILTERS_TYPES_TO_STRATEGY_MAP = {
    'plannedDepartureTime': FILTER_STRATEGY_TYPES.DATE_TIME_RANGE_STRATEGY,
    'contractorPostalCode': FILTER_STRATEGY_TYPES.INPUT_STRATEGY,
    'plannedFloorPalletSpaces': FILTER_STRATEGY_TYPES.CHECKBOX_GROUP_RANGE_STRATEGY,
    'transportOrderNumber': FILTER_STRATEGY_TYPES.NUMBER_INPUT_STRATEGY,
    'truckLicensePlate': FILTER_STRATEGY_TYPES.INPUT_STRATEGY,
    'contractorName1': FILTER_STRATEGY_TYPES.MULTISELECT_AUTOCOMPLETE_STRATEGY,
    'weight': FILTER_STRATEGY_TYPES.INPUT_NUMBER_RANGE_STRATEGY,
    'status': FILTER_STRATEGY_TYPES.CHECKBOX_GROUP_STRATEGY,
    'stops': FILTER_STRATEGY_TYPES.CHECKBOX_GROUP_STRATEGY,
    'tourNo':  FILTER_STRATEGY_TYPES.INPUT_NUMBER_RANGE_STRATEGY,
    'HasProductGroup': FILTER_STRATEGY_TYPES.CHECKBOX_GROUP_STRATEGY,
    'transportMode': FILTER_STRATEGY_TYPES.CHECKBOX_GROUP_STRATEGY,
    'plannedVolumePalletSpaces': FILTER_STRATEGY_TYPES.CHECKBOX_GROUP_RANGE_STRATEGY
};


export const TRANSPORT_ORDERS_FILTERS_TYPES_TO_STRATEGY_MAP = {
    'transportOrderNumber': FILTER_STRATEGY_TYPES.NUMBER_INPUT_STRATEGY,
    'truckLicensePlate': FILTER_STRATEGY_TYPES.INPUT_STRATEGY,
};

export const TRANSPORT_ORDERS_FILTER_OPERATORS_MAP = {
    'truckLicensePlate': FILTER_OPERATORS.CONTAINS,
    'transportOrderNumber': FILTER_OPERATORS.EQUAL
};
